var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWriteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5974 20.7306C15.4251 20.9029 15.1914 20.9997 14.9477 20.9997C14.704 20.9997 14.4703 20.9029 14.2979 20.7306L12.8404 19.273C12.6681 19.1007 12.5713 18.867 12.5713 18.6233C12.5713 18.3796 12.6681 18.1459 12.8404 17.9735L17.974 12.8399C18.1464 12.6676 18.3801 12.5708 18.6238 12.5708C18.8675 12.5708 19.1012 12.6676 19.2735 12.8399L20.7311 14.2974C20.9034 14.4698 21.0002 14.7035 21.0002 14.9472C21.0002 15.1909 20.9034 15.4246 20.7311 15.5969L15.5974 20.7306Z",
    stroke: "white",
    strokeWidth: 1.65424,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7044 13.1093L16.4407 6.79189C16.4063 6.62002 16.3235 6.46155 16.2021 6.33519C16.0806 6.20883 15.9255 6.11985 15.7551 6.07873L4.135 3.02574C3.98191 2.98873 3.82189 2.99168 3.67027 3.0343C3.51866 3.07693 3.38054 3.15781 3.26918 3.26918C3.15781 3.38054 3.07693 3.51866 3.0343 3.67027C2.99168 3.82189 2.98873 3.98191 3.02574 4.135L6.07873 15.7551C6.11985 15.9255 6.20883 16.0806 6.33519 16.2021C6.46155 16.3235 6.62002 16.4063 6.79189 16.4407L13.1093 17.7044M3.27571 3.27571L9.97171 9.97171",
    stroke: "white",
    strokeWidth: 1.65424,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2716 13.1091C12.2868 13.1091 13.1097 12.2862 13.1097 11.271C13.1097 10.2559 12.2868 9.43298 11.2716 9.43298C10.2565 9.43298 9.43359 10.2559 9.43359 11.271C9.43359 12.2862 10.2565 13.1091 11.2716 13.1091Z",
    stroke: "white",
    strokeWidth: 1.65424,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWriteIcon);
export default __webpack_public_path__ + "static/media/write-icon.b23d4699a6730b58a6afea8eb4e4c9d1.svg";
export { ForwardRef as ReactComponent };